import React from 'react';
import {ItemPresenter} from "../ItemPresenter";

const className = "wolfpelt";

function GIWolfPelt() {
  return (
    <ItemPresenter imagePath={`/images/gameItems/${className}.png`} tooltipText={className} />
  );
}

export default GIWolfPelt;